import { Collapse as AntdCollapse } from "antd"
import cx from "clsx"
import styles from "./collapse.module.less"

const CollapseCustom = props => {
  return <AntdCollapse className={cx(props.class, styles.collapseOuter)} {...props} />
}

const CollapsePanelCustom = props => {
  return <AntdCollapse.Panel {...props} />
}

export { CollapseCustom, CollapsePanelCustom }
